import React from "react";
import styles from "./index.module.scss";
// import tinkoff from "../../assets/img/footer/tinkoff.svg";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

const Footer = () => {
  return (
    <footer>
      <Container className={styles.container} fluid>
        <Row className={styles.row_titles}>
          <Col className={styles.logo}>ТАМАРА</Col>
          <Col>Покупателям</Col>
          <Col>Сотрудничество</Col>
          <Col> Контакты</Col>
        </Row>
        <Row className={styles.row_2} xl={4}>
          <Col></Col>
          <Col>Оплата</Col>
          <Col>Оптовым покупателям</Col>
          <Col> +7 926 856 11 11</Col>
        </Row>
        <Row xl={4}>
          <Col></Col>
          <Col>Возврат</Col>
          <Col>О компании</Col>
          <Col>tamara@gmail.com</Col>
        </Row>
        <Row xl={4}>
          <Col></Col>
          <Col>Доставка</Col>
          <Col> Контакты</Col>
          <Col> Якутск, Ул. Лебедева</Col>
        </Row>
        <Row xl={4}>
          <Col> 2022. Все права защищены</Col>
          <Col></Col>
          <Col></Col>
          <Col>
            {" "}
            <img className={styles.tinkoff} alt="" />
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
